const specs = {
  width: 620,
  title: {
    update: 'pages.fireSources.modal.update.single.title',
    create: 'pages.fireSources.modal.create.single.title'
  },
  okText: {
    update: 'pages.fireSources.modal.update.single.okText',
    create: 'pages.fireSources.modal.create.single.okText'
  },
  actions: {
    delete: {
      buttonType: 'danger'
    }
  },
  rows: {
    name: {
      title: 'pages.fireSources.fields.name.title',
      dataIndex: 'name',
      key: 'name',
      formField: {
        label: 'pages.fireSources.fields.name.title',
        required: 'pages.fireSources.fields.name.requiredMessage',
        placeholder: 'pages.fireSources.fields.name.placeholder'
      },
      empty: 'common.unknown.male'
    }
  }
}

export default specs
